/**
 *
 * @param context React context
 * @param field
 * @returns {function(event)}
 */
export function setField(context, field) {
    return (e) => {
        context.setState({
            [field]: e && e.target ? e.target.value : e,
        });
    };
}
/**
 *
 * @param context React context
 * @returns {function(event)}
 */
export function handleFieldChange(context) {
    return (e) => {
        context.setState({
            [e.target.id]: e.target.value,
        });
    };
}
